import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';

interface ISelectSubscriptionProps {
    priceId: string;
    count?: number;
    zip?: string;
    state?: string;
    productEnum?: string;
}

interface ISelectSubscriptionResponse {
    redirectUrl: string;
}

const selectSubscribeOption = async ({
    priceId,
    count,
    zip,
    state,
    productEnum,
}: ISelectSubscriptionProps) => {
    const response = await apiClient.post('subscribe', {
        json: {
            priceId,
            count,
            zip,
            state,
            productEnum,
        },
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return (await response.json()) as ISelectSubscriptionResponse;
};

export const useSubscribeOptionMutation = (
    options: UseMutationOptions<
        ISelectSubscriptionResponse,
        IRequestException,
        ISelectSubscriptionProps
    >
) => {
    return useMutation(
        async (props) => await selectSubscribeOption(props),
        options
    );
};
